<script type="text/babel">
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import RestoreScrollOnPageBack from 'dashboard-js/mixins/RestoreScrollOnPageBack'

export default {
    mixins: [ManagesModalState, RestoreScrollOnPageBack],

    props: ['course', 'user'],

    data() {
        return {}
    },

    computed: {
        currentStep() {
            return 1; // only 1 video
        },
    },

    created() {},

    methods: {
        navigateToQuestions() {
            if (!this.course.course_question.length) {
                return
            }

            window.location.href = `/school/course/${this.course.id}/question/${this.course.course_question[0].id}`
        },
        navigateToCourse() {
            window.location.href = `/school/course/${this.course.id}`
        },
    },
}
</script>

